import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
    label: string;
}

const useStyles = makeStyles((theme: any) => ({
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    },
    label: {
        fontSize: '0.75rem',
        textTransform: 'uppercase' as const,
        letterSpacing: '0.06em',
        color: theme.palette.common.darkGrey,
        opacity: 0.55,
        whiteSpace: 'nowrap' as const,
    },
    rule: {
        flex: 1,
        height: 1,
        background: theme.palette.common.inputDisabledGray,
    },
}));

export const StepLabel = ({ label }: Props) => {
    const classes = useStyles();

    return (
        <div className={classes.row}>
            <Typography component="span" className={classes.label}>
                {label}
            </Typography>
            <span className={classes.rule} aria-hidden="true" />
        </div>
    );
};
